"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _audio = _interopRequireDefault(require("@atlaskit/icon/core/audio"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const AudioIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M19 6.673V15.2a2.8 2.8 0 0 1-2.8 2.8h-.4a2.8 2.8 0 0 1-2.8-2.8v-.4a2.8 2.8 0 0 1 2.8-2.8h.4q.419.001.8.116V8.242l-6 .621V16.2A2.8 2.8 0 0 1 8.2 19h-.4A2.8 2.8 0 0 1 5 16.2v-.4A2.8 2.8 0 0 1 7.8 13h.4q.419.001.8.116V6.654c0-.38.31-.721.72-.764l8.56-.886c.398-.041.72.235.72.615z"/></svg>`
}, props, {
  newIcon: _audio.default
}));
AudioIcon.displayName = 'AudioIcon';
var _default = exports.default = AudioIcon;